var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"contacts"},[_c('v-title',{attrs:{"title":"Contact"}}),_vm._l((_vm.contacts),function(contact,i){return _c('v-contact',{key:("contact-" + i),attrs:{"contact":contact}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }